import React, {useState, useEffect} from 'react';
import { useSelector,useDispatch  } from 'react-redux';

import TranscriptionDisplay from '../../MediaPlayback/components/VoiceTranscription/TranscriptionDisplay/TranscriptionDisplay';
import { leaveRoomSocket, setCurrentRoom } from '../../Map/store/MapDisplaySlice';
import { setRecorderStatus, setRecorderData } from '../slice/recorderSlice';

import { triggerRecordingStop } from '../hooks/useRoomRecording';
import { CircleDot } from 'lucide-react';

import useRecordingTimer from '../hooks/useRecordingTimer';
import { tenantHasFeature } from '../../Auth/utils/AuthUtils';

function StatusBar(props) {
    const dispatch = useDispatch(); // ← ajoute
    const currentRoom = useSelector((state) => state.MapDisplay.currentRoom); // ← ajoute
    const duration = useRecordingTimer();
    const recorder = useSelector(
        (state) => state.recorder
    );
    console.log(
        "STATUS BAR RECORDER",
        recorder
      );

    const isRecording =
        recorder.status === 'recording';

    const hasTranscription = props.TSstatus === "active";
    const [notifIgnored, setNotifIgnored] = useState(false);

    // Reset quand l'enregistrement s'arrête
    const showRecordingNotif = !recorder.isOwner && recorder.status === 'recording' && !notifIgnored;

    useEffect(() => {
        if (recorder.status !== 'recording') {
            setNotifIgnored(false);
        }
    }, [recorder.status]);

    return (

        <div     className="trs-display-container">
            {/* ───────── TRANSCRIPTION ───────── */}
            {props.TSstatus === "active" && tenantHasFeature("TRANSCRIPTION_ENABLED") && (
                <div className="transcription-section">
                    <TranscriptionDisplay {...props} />
                </div>
            )}
{/*
            {showRecordingNotif && (
                <RecordingNotification
                    recorderName={recorder.recorderName}
                    onIgnore={() => setNotifIgnored(true)}
                    onLeave={() => {
                        dispatch(leaveRoomSocket({ roomId: currentRoom?.room_id }));
                        dispatch(setCurrentRoom(null));
                        dispatch(setRecorderStatus('idle'));        // ← cache la barre
                        dispatch(setRecorderData({
                            recorderName: null,
                            isOwner: false,
                            duration: '00:00',
                        }));
                        setNotifIgnored(true);
                    }}
                />
            )}
*/}
            {/* ───────── RECORDER ───────── */}
            {isRecording &&  tenantHasFeature("RECORD_SYSTEM_ENABLED") && (
                <div
                    className={`recorder-section ${hasTranscription ? "recorder-section--with-transcription" : ""}`}
                    style={styles.wrapper(hasTranscription)}
                >
                    {/* Right */}
                    <div style={styles.leftSection}>
                    <CircleDot size={'1.125rem'} color="#E53935" strokeWidth={3} />

                        <span style={styles.label}>
                            {
                                recorder.isOwner
                                    ? `Enregistrement`
                                    : `${recorder.recorderName} enregistre`
                            }
                        </span>
                        <span style={styles.timer}>
                            {duration}
                        </span>
                    </div>
                    {/* STOP */}
                    {(recorder.isOwner || true) && (
                        <button
                            style={styles.stopButton}
                            onClick={triggerRecordingStop}
                        >
                            Arrêter
                        </button>
                    )}

                </div>
            )}

        </div>
    );
}

const styles = {

    wrapper: (hasTranscription) => ({

        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '1.5625rem',
        position: 'relative',
        paddingTop: hasTranscription? '0.5rem':'0.25rem',
        padding : '0.3125rem 0.5rem',
        width: '100%',
        boxSizing: 'border-box',
    }),

    leftSection: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.25rem',
    },

    recordIcon: {

        width: '1.125rem',
        height: '1.125rem',
        borderRadius: '50%',
        border: '2px solid #E53935',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
    },

    innerDot: {

        width: '0.375rem',
        height: '0.375rem',
        borderRadius: '50%',
        background: '#E53935',
    },

    label: {
        fontSize: '0.75rem',
        color: '#2E2E2E',
        fontWeight: 500,
        
    },

    timer: {
        fontSize: '0.875rem',
        color: '#E53935',
        fontWeight: 500,
        minWidth: '2.625rem',
    },

    stopButton: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        border: '1px solid #D5D7DA',
        background: '#FFF5F5',
        color: '#B42318',
        borderRadius: '0.625rem',
        padding: 'auto',
        cursor: 'pointer',
        fontSize: '0.75rem',
        fontWeight: 500,

        width: 'auto',
        height:'1.625rem',
    },
};

export default StatusBar;